<template>
	<div class="my-item" @click="itemJump(itemindex)">
		<div class="item-content">
			<section class="template-box">
				<div class="left">
					<card-detail :cardData="iteminfo"></card-detail>
					<div v-if="iteminfo.ProductId == 1 && iteminfo.ExtendData && iteminfo.ExtendData.ShowCardAsList && iteminfo.ExtendData.ShowCardAsList.length > 0">
						<div v-for="(item, idx) in iteminfo.ExtendData.ShowCardAsList" :key="idx">
							<card-detail :cardData="item"></card-detail>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="price" v-if="iteminfo.ProductId == 613 && iteminfo.ExtendData">
						<span class="price-symbol" v-if="iteminfo.ExtendData.ActCostType != 2">{{iteminfo.ExtendData.Currency||"&yen;"}}</span>						
						<span class="price-num">{{iteminfo.ExtendData.ActCostPrice}}</span>
					</div>
					<div class="price" v-else-if="iteminfo.ProductId == 47 || iteminfo.ProductId == 34">
						<span class="price-symbol" v-if="iteminfo.CostPrice>0">{{iteminfo.ExtendData.Currency||"&yen;"}}</span>						
						<span class="price-num" v-if="iteminfo.CostPrice>0">{{iteminfo.CostPrice}}</span>
					</div>
					<div class="price" v-else>
						<template>
							<span class="price-symbol">{{iteminfo.ExtendData.Currency||"&yen;"}}</span>							
							<span class="price-num" v-if="iteminfo.ProductId == 607 && iteminfo.ExtendData">{{iteminfo.ExtendData.ActCostPrice}}</span>
							<span class="price-num" v-else>{{iteminfo.CostPrice}}</span>
						</template>
						<div class="member-price" v-if="(iteminfo.ProductId == 1 && iteminfo.ExtendData && iteminfo.ExtendData.IsDHOrder && iteminfo.ExtendData.IsDHOrder == 1)">航司优享价</div>
					</div>
					<div class="status" v-if="!!iteminfo.OrderStatusDesc">{{iteminfo.OrderStatusDesc}}</div>
				</div>
			</section>
			<div class="remainder-time" v-if="iteminfo.ExtendData && (!!iteminfo.ExtendData.IsPayBtnShow || !!iteminfo.ExtendData.IsShowGuarantee) && iteminfo.ExtendData.ExpireDateTime && getRemainder(iteminfo.ExtendData.ExpireDateTime)">
				<img src="https://file.40017.cn/ddjapp/wxService/orderlist/sysj.png" />
				<span>剩余支付时间</span>
				<label>{{getRemainder(iteminfo.ExtendData.ExpireDateTime)}}</label>
			</div>
			<section class="message" v-if="iteminfo.ProductId == 9 && iteminfo.ExtendData && iteminfo.ExtendData.StopSaleFlag && iteminfo.ExtendData.StopSaleFlag != 0">
				<span class="message-text">该车次已停运，如需退票请进入详情操作</span>
			</section>
			<section class="message" v-if="iteminfo.ProductId == 1 && iteminfo.ExtendData && iteminfo.ExtendData.IsRestoring && iteminfo.ExtendData.IsRestoring == 1">
				<span class="message-text">航信系统维护，完成后优先出票，若出票失败全额退款</span>
			</section>
			<section class="message" v-if="iteminfo.ProductId == 1 && iteminfo.ExtendData && iteminfo.ExtendData.IsFlightAlter && iteminfo.ExtendData.IsFlightAlter == 1">
				<span class="message-text" style="color: #c1913a;">航班发生变动，请及时查看</span>
			</section>
			<div class="orderbtn" v-if="iteminfo.Buttons.length <= 3 && iteminfo.Buttons.length > 0">
				<div class="orderbtns-btn" v-for="(item,index) in iteminfo.Buttons" v-on:click.stop="orderBtnClick(item,iteminfo)" :class="item.Type == 'zhifu' ? 'orange':'default'" :key="index">
					<div>{{item.Title}}</div>
				</div>
			</div>
			<div class="orderbtn-multiple" v-else-if="iteminfo.Buttons.length > 3">
				<div class="more-btn default" @click.stop="moreBtnClick">
					更多
					<div class="more-btn-content" v-if="isShowMore">
						<span class="triangle"><em></em></span>
						<div class="more-item">
							<div v-for="(item, index) in renderBtn" v-if="index < iteminfo.Buttons.length - 2" v-on:click.stop="orderBtnClick(item,iteminfo)" :key="index">{{item.Title}}</div>
						</div>
					</div>
				</div>
				
				<div class="orderbtns-btn" v-for="(item, index) in iteminfo.Buttons" v-if="index >= iteminfo.Buttons.length - 2" v-on:click.stop="orderBtnClick(item,iteminfo)" :class="item.Type == 'zhifu' ? 'orange':'default'" :key="index">
					<div>{{item.Title}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		order,
		canceldata
	} from '../util/order.js'
	import {
		api,
		devType,
		miniAppVer,
		enterType
	} from '../util/api.js'
	import {
		openUrl,
		getCookie
	} from '../util/tool.js'
	import axios from 'axios'
	import Bus from './bus.js'
	import Toast from './toast/toast.js'
	import CardDetail from '../template/CardDetail'
	const defaultProjects = [4, 8, 9]
	export default {
		components: {
			CardDetail
		},
		props: [
			'iteminfo',
			'mainList',
			'itemindex',
			'position',
			'actposition',
			'cancelReasonProjects'
		],
		data() {
			return {
				cancel: {
					showCancel: false,
					couldCancel: false,
					cancelReason: [],
					reason: {},
					card: null,
				},
				clientHeight: document.documentElement.clientHeight + 'px',
				radioSelect: [],
				isShowMore: false				
			}
		},
		watch: {
			actposition(newVal) {
				if(newVal == this.position) return
				this.isShowMore = false
			}
		},
		computed: {
			//按钮超过3个显示更多
			renderBtn: function() {
				return this.iteminfo.Buttons //.slice(3)
			},
			wxJssdk() {
				return this.$root.wxJssdk
			}
		},
		mounted() {
			
		},
		methods: {
			itemJump: function(itemindex) {
				if (this.iteminfo.DetailLink) {
					window.location.href = this.iteminfo.DetailLink;
					AppendTrack(category, action, label, '^详情^' + this.iteminfo.ProductName + '^' + this.iteminfo.OrderStatusDesc + '^')
					AppendTrack(category, action, label, '^订单操作^详情^' + this.iteminfo.ProductName + '^' + this.iteminfo.OrderStatusDesc + '^' + itemindex + '^')
				}
				this.isShowMore = false
				this.$emit('closeMore', {
					actposition: this.position
				})
			},
			getRemainder: function(date) {
				let time = new Date(date.replace(/\-/igm, '/')).getTime() - new Date().getTime()
				if (isNaN(time) || time < 0) {
					return
				}
				let days = Math.floor(time / (24 * 3600 * 1000)),
					time1 = time % (24 * 3600 * 1000),
					hours = Math.floor(time1 / (3600 * 1000)),
					time2 = time1 % (3600 * 1000),
					minutes = Math.floor(time2 / (60 * 1000)),
					time3 = time2 % (60 * 1000),
					seconds = Math.round(time3 / 1000)

				let str = `${
						days > 0 ? days + '天' : ''
					}${
						hours > 0 ? hours > 9 ? hours + '小时' : hours + '小时' : ''
					}${
						minutes > 0 ? minutes > 9 ? minutes + '分钟' : minutes + '分钟' : ''
					}${
						false ? seconds > 9 ? seconds + '秒' : '0' + seconds + '秒' : ''
					}`.replace(/\s+/g, '');

				return str;
			},
			orderBtnClick(btninfo, iteminfo) {
				const btn = btninfo,
					card = iteminfo;
				switch (btn.Type) {
					case 'cuichupiao':
						this.hasten()
						break
					case 'tel':
						this.makePhone(btn.ActionUrl)
						break
					case 'daohang':
						this.gps(btn.ActionUrl, card)
						break
					
					case 'tuikuanjindu':
						this.refund(btn.ActionUrl)
						break
					case 'shanchu':
						Bus.$emit('showdialog', {
							title: '删除订单记录不等于取消预订',
							describle: '删除后订单记录无法还原和查询，确定删除吗？',
							iscancel: '点错了',
							istrue: '删除订单',
							callbackf: this.removeOrder.bind(this)
						})
						break
					case 'quxiao':					    
						if (this.getCancelReasonProjects().indexOf(card.ProductId)!=-1) {
							this.getCancelReason();
						} else {
						    this.cancelConfirm()
						}
						break
					case 'zhifu':
						if (card.ProductId == 1 && card.ExtendData && card.ExtendData.IsUnionPay && card.ExtendData.IsUnionPay == 1) {
							let txt ='' // '您预订的订单为多程组合机票，需要同时支付~'
							if(typeof card.ExtendData.IsDHOrder != 'undefined' && card.ExtendData.IsDHOrder != 0) {
								txt = '该订单为东航优享组合订单，包含优享价需要同时支付~'
							}else if(card.ExtendData.AirlineType==6){
								txt = '您预订的订单为多程组合机票，需要同时支付~'
							}
							if(txt!=''){
								Bus.$emit('showdialog', {
									title: '去支付',
									describle: txt,
									iscancel: '点错了',
									istrue: '去支付',
									callbackf: () => {
										openUrl(btn.ActionUrl)
									}
								})
							}else{
								openUrl(btn.ActionUrl)
							}
						} else if (card.ProductId == 13 && card.ExtendData && card.ExtendData.IsUnitePay && card.ExtendData.IsUnitePay == 1) {
							Bus.$emit('showdialog', {
								title: '去支付',
								describle: '您预订的订单为多程组合机票，需要同时支付',
								iscancel: '点错了',
								istrue: '去支付',
								callbackf: () => {
									openUrl(btn.ActionUrl)
								}
							})
						} else {
							openUrl(btn.ActionUrl)
						}
						break
					default:
						if(btn.ActionUrl) {
							openUrl(btn.ActionUrl)
						}
						break
				}
				this.isShowMore = false
				AppendTrack(category, action, label, '^按钮曝光^' + btninfo.Title + '^' + this.iteminfo.ProductName + '^' + this.iteminfo.OrderStatusDesc + '^' + this.itemindex + '^')
			},
			cancelRequst(reason) {
				const card = this.iteminfo
				this.$toast('正在取消订单', 'center', 5000)
				let extData = {}
				if (card.ExtendData) {
					if (typeof card.ExtendData.OrderType !== 'undefined' && card.ExtendData.OrderType) {
						extData['OrderType'] = card.ExtendData.OrderType
					}
					if (typeof card.ExtendData.DelOrderUrl !== 'undefined' && card.ExtendData.DelOrderUrl) {
						extData['DelOrderUrl'] = card.ExtendData.DelOrderUrl
					}
					if (typeof card.ExtendData.ChannelId !== 'undefined' && card.ExtendData.ChannelId) {
						extData['ChannelId'] = card.ExtendData.ChannelId
					}
					if (typeof card.ExtendData.OrderFlag !== 'undefined' && card.ExtendData.OrderFlag) {
						extData['OrderFlag'] = card.ExtendData.OrderFlag
					}
					if (typeof card.ExtendData.OrderFrom !== 'undefined' && card.ExtendData.OrderFrom) {
						extData['OrderFrom'] = card.ExtendData.OrderFrom
					}
					if (typeof card.ExtendData.CancelOrderUrl !== 'undefined' && card.ExtendData.CancelOrderUrl) {
						extData['CancelOrderUrl'] = card.ExtendData.CancelOrderUrl
					}					
					if (reason) {
						extData = Object.assign(extData, {
							"Id": reason.Id,
							"KeyValue": reason.KeyValue,
							"Reason": encodeURIComponent(reason.Reason),
						})
					}
				}
				axios.post(api.ServiceOrderCancel, {
					productId: card.ProductId,
					MemberId: encodeURIComponent(card.MemberId),
					OrderSerialId: card.SerialNo,
					OrderId: card.OrderId,
					ExtendData: extData,
					OperToken: card.OperToken,
					cts: new Date().getTime(),
					enterType: enterType,
					OperExtendData : card.OperExtendData || null
				}).then((res) => {
					let time = card.ProductId == 18 && success ? 1000 : 1000
					if (res.data && res.data.IsSucess) {
						setTimeout(() => {
							this.$toast('取消成功', 'center', 1000)
							this.$emit('cancelItem', {})
						}, time)
					} else {
						setTimeout(() => {
							this.$toast('取消失败', 'center', 1000)
						}, time)
					}
				}).catch(() => {})
			},
			//删除订单
			removeOrder() {
				const card = this.iteminfo
				let me = this;
				let desc = '删除失败，请稍后再试~',
					success = false
				this.$toast('正在删除订单', 'center', 5000);
				let extData = {}
				if (card.ExtendData) {
					if (typeof card.ExtendData.OrderType !== 'undefined' && card.ExtendData.OrderType) {
						extData['OrderType'] = card.ExtendData.OrderType
					}
					if (typeof card.ExtendData.DelOrderUrl !== 'undefined' && card.ExtendData.DelOrderUrl) {
						extData['DelOrderUrl'] = card.ExtendData.DelOrderUrl
					}
					if (typeof card.ExtendData.ChannelId !== 'undefined' && card.ExtendData.ChannelId) {
						extData['ChannelId'] = card.ExtendData.ChannelId
					}
					if (typeof card.ExtendData.OrderFlag !== 'undefined' && card.ExtendData.OrderFlag) {
						extData['OrderFlag'] = card.ExtendData.OrderFlag
					}
					if (typeof card.ExtendData.OrderFrom !== 'undefined' && card.ExtendData.OrderFrom) {
						extData['OrderFrom'] = card.ExtendData.OrderFrom
					}
					if (typeof card.ExtendData.CancelOrderUrl !== 'undefined' && card.ExtendData.CancelOrderUrl) {
						extData['CancelOrderUrl'] = card.ExtendData.CancelOrderUrl
					}
					axios.post(api.ServiceOrderDelete, {
						productId: card.ProductId,
						MemberId: encodeURIComponent(card.MemberId),
						OrderSerialId: card.SerialNo,
						OrderId: card.OrderId,
						ExtendData: extData,
						miniAppVer: miniAppVer,
						cts: new Date().getTime(),
						devType: devType,
						MemberId: card.MemberId,
						OperToken: card.OperToken,
						enterType: enterType,
						OperExtendData : card.OperExtendData || null
					}).then(res => {
						if (res.data && res.data.IsSucess) {
							setTimeout(() => {
								me.$toast('删除成功', 'center', 1000);
								me.$emit('deleteItem', {
									orderId: card.OrderId,
									serialNo: card.SerialNo,
									productId: card.ProductId
								})
							}, 500);
						} else {
							setTimeout(() => {
								me.$toast('删除失败', 'center', 1000);
							}, 1000)
						}
					}).catch(error => {})
				}
			},
			//获取取消的原因
			getCancelReason() {
				if (this.cancel.cancelReason && this.cancel.cancelReason.length > 0) {
					this.cancel.showCancel = true;
					Bus.$emit('showCanceldialog', this.cancel)
					return
				}
				let extData = {}				
				const card = this.iteminfo;
				if (typeof card.OrderStatus !== 'undefined' && card.OrderStatus) {
            		extData['OrderStatus'] = card.OrderStatus
				}
				if (typeof card.ExtendData.PaymentType !== 'undefined' && card.ExtendData.PaymentType) {
          			extData['PaymentType'] = card.ExtendData.PaymentType
        		}
				axios.post(api.CancelReason, {
					productId: card.ProductId,
					cts: new Date().getTime(),
					ExtendData:extData,
					enterType: enterType,
				}).then((res) => {					
					try{
						if (res.data && res.data.IsSucess && res.data.Body && res.data.Body.length > 0) {
							this.cancel.card = this.iteminfo;
							this.cancel.cancelReason = res.data.Body,
							this.cancel.CallBack = this.cancelRequst.bind(this),
							Bus.$emit('showCanceldialog', this.cancel)
						} else {						
							this.cancelConfirm()
							//this.$toast('取消失败', 'center', 2000)
						}
					}catch(e){
                        this.cancel.cancelReason=[]								
					    this.cancelConfirm()
					}					
				}).catch((error) => {					
					this.cancel.cancelReason=[]								
					this.cancelConfirm()
					//this.cancel()
				})
			},
			hasten() {
				let title = '催失败',
					message = '催单失败，请稍后再试~'

				const card = this.iteminfo;

				axios.post(api.Hasten, {
					productId: card.ProductId,
						MemberId: encodeURIComponent(card.MemberId),
						SerialNo: card.SerialNo,
						OrderId: card.OrderId,
						miniAppVer: miniAppVer,
						cts: new Date().getTime(),
						devType: devType,
						MemberId: card.MemberId,
						OperToken: card.OperToken,
						enterType: enterType
				}).then(res => {
					if (res.data && res.data.IsSucess) {
						title = '催成功'
						message = res.data.Body.Message
					}
					this.$dialog({
						title, 
						okTxt: '知道了',
						isSingleButton: true,
						message
					})
				}).catch(error => {
					this.$dialog({
						title, 
						okTxt: '知道了',
						isSingleButton: true,
						message
					})
				}) 
			},
			refund(url) {
				const card = this.iteminfo;
				let openId = getCookie('WxUser') && getCookie('WxUser').split('=')[1] || ''
				let href = `${url}&openId=${openId}`;
				href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3827070276e49e30&redirect_uri=https%3a%2f%2fwx.17u.cn%2fwxinfo%2fWxMember%2fRedirectBind%3furl%3d${encodeURIComponent(encodeURIComponent(href))}%26hasCode%3dfalse&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
				openUrl(url)
			},
			gps(data, info) {
				if(!this.wxJssdk) {
					this.$toast('调用地图失败，请稍后再试~', 'center', 1000)
					return
				}
				let itude = JSON.parse(data)
				let longitude = itude[0]
				let latitude = itude[1]
				try{
					wx.openLocation({
						longitude: longitude, //经度
						latitude: latitude, //纬度
						name: info.Title,
						scale: 16,
						fail: e => {
							throw new Error(e)
						}
					})
				} catch (err) {
					this.$toast('调用地图失败，请稍后再试~', 'center', 1000)
				}
			},
			makePhone(phone) {
				let phoneList = phone && phone.split(',')
				if (phoneList.length == 1) {
					location.href = `tel:${phone}`
				} else {
					this.$showTelList(phoneList)
				}
			},
			moreBtnClick() {
				this.isShowMore = !this.isShowMore;
				this.$emit('closeMore', {
					actposition: this.position
				})
			},
			cancelConfirm(){
				const card = this.iteminfo;				
				if (card.ProductId == 1) {
					let txt='是否确认取消该订单？'
					if (card.ExtendData && card.ExtendData.IsUnionPay && card.ExtendData.IsUnionPay == 1) {						
						if(typeof card.ExtendData.IsDHOrder != 'undefined' && card.ExtendData.IsDHOrder != 0) {
							txt = '该订单为东航优享组合订单，包含优享价需要同时取消~'
						} else  if(card.ExtendData.AirlineType==6){
							txt = '您预订的订单为多程组合机票，需要同时取消~'
						}						
					} 
					Bus.$emit('showdialog', {
							title: '取消订单',
							describle: txt,
							iscancel: '点错了',
							istrue: '立即取消',
							callbackf: this.cancelRequst.bind(this)
				    })
				} else if (card.ProductId == 13) {
					if (card.ExtendData && card.ExtendData.IsUnitePay && card.ExtendData.IsUnitePay == 1) {
						Bus.$emit('showdialog', {
							title: '取消订单',
							describle: '您预订的订单为多程组合机票，需要同时取消',
							iscancel: '点错了',
							istrue: '立即取消',
							callbackf: this.cancelRequst.bind(this)
						})
					} else {
						Bus.$emit('showdialog', {
							title: '取消订单',
							describle: '是否确认取消该订单？',
							iscancel: '点错了',
							istrue: '立即取消',
							callbackf: this.cancelRequst.bind(this)
						})
					}
				} else {
					Bus.$emit('showdialog', {
						title: '取消订单',
						describle: '是否确认取消该订单？',
						iscancel: '点错了',
						istrue: '立即取消',
						callbackf: this.cancelRequst.bind(this)
					})
				}
			},
			getCancelReasonProjects(){
                if(this.cancelReasonProjects&&this.cancelReasonProjects.length){
					var projects=this.cancelReasonProjects.slice(0)
					for(var i=0;i<defaultProjects.length;i++){
						projects.push(defaultProjects[i])
					}
					return projects
				}
				return defaultProjects
			}
		}
	}
</script>
<style scoped>
	.template-box {
		display: -webkit-box;
		-webkit-box-pack: justify;
		padding: 5px 15px 0 10px;
	}
	.left {
		-webkit-box-flex: 1;
	}
	.right {
		margin-left: 10px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-align: end;
	}
	.right .price {
		height: 45px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-box-align: end;
		position: relative;
	}
	.right .member-price {
		white-space: nowrap;
		color: #999;
		font-size: 10px;
		text-align: right;
	}
	.right .price-symbol {
		font-size: 9px;
		font-weight: bold;
		color: #ff5346;
	}
	.right .price-num {
		font-size: 16px;
		font-weight: bold;
		color: #ff5346;
	}
	.right .status {
		display: block;
		font-size: 12px;
		color: #333;
	}
	.my-item {
		padding: 0 10px;
	}
	.item-content {
		background: #fff;
		padding-bottom: 18px;
		border-radius: 9px;
		margin: 10px 0;
		text-align: left;
	}
	.titleDesc-box {
		-webkit-box-flex: 1;
	}
	.title-descible {
		width: 100%;
		display: -webkit-box;
		-webkit-box-pack: justify;
	}
	.price-status {
		display: -webkit-box;
		/* autoprefixer: off */
		-webkit-box-orient: vertical;
		/* autoprefixer: on */
		-webkit-box-align: end;
		width: 1.2rem;
		white-space: nowrap;
	}
	.price {
		color: #ff5346;
		height: 0.9rem;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-box-align: end;
	}
	.price-num {
		font-size: 0.32rem;
		font-weight: bold;
		font-family: 'Microsoft YaHei';
	}
	.price-num label {
		font-size: 0.24rem;
		font-weight: bold;
		color: #ff5346;
		font-family: 'Microsoft YaHei';
	}
	.status {
		display: block;
		font-size: 0.24rem;
		color: #333;
	}
	.remainder-time {
		background: #F4F6FA;
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		box-sizing: border-box;
		border-radius: 5px;
		font-size: 0.26rem;
		margin: 12px 15px 0 45px;
	}
	.remainder-time img {
		width: 0.32rem;
		display: inline-block;
		vertical-align: middle;
	}
	.remainder-time label {
		color: #ff5346;
		display: inline-block;
		vertical-align: middle;
	}
	.remainder-time span {
		display: inline-block;
		vertical-align: middle;
	}
	.orderbtn, .orderbtn-multiple {
		width: 100%;
		box-sizing: border-box;
		margin-top: 0.36rem;
		display: -webkit-box;
		padding-right: 15px;
		padding-bottom: 0;
		-webkit-box-pack: end;
	}
	 .orderbtns-btn {
		margin-left: 10px;
		border-radius: 0.3rem;
		text-decoration: none;
		width: 1.8rem;
		text-align: center;
		font-size: 0.28rem;
		height: 0.6rem;
		display: -webkit-box;
		-webkit-box-pack: center;
		-webkit-box-align: center;
	}
	.orderbtns-btn:first-child {
		margin-left: 0;
	}
	.orderbtns-btn div {
		-webkit-box-flex: 1;
		display: block;
	}
	.default {
		color: #333;
		border: 1px solid rgba(144, 144, 144, 0.5)
	}
	.orange {
		background: -webkit-linear-gradient(#ff6957, #ff5649);
		color: #fff;
	}
	.more-btn {
		border-radius: 0.3rem;
		text-decoration: none;
		width: 1.8rem;
		text-align: center;
		font-size: 0.28rem;
		height: 0.6rem;
		display: -webkit-box;
		-webkit-box-pack: center;
		-webkit-box-align: center;
		position: relative;
	}
	.more-btn label {
		display: inline-block;
		font-size: 15px;
	}
	.more-item {
		border: 1px solid #ccc;
		border-radius: 5px;
	}
	.more-btn-content {
		position: absolute;
		right: 50%;
		transform: translateX(50%);
		top: 38px;
		z-index: 1020;
		margin-top: 6px;
		text-align: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-box-align: end;
		background: #fff;
	}
	.more-item div {
		height: 0.6rem;
		line-height: 0.6rem;
		border-bottom: 1px solid #ccc;
		width: 1.4rem;
		margin: 0.05rem 0.2rem;
	}
	.more-item div:last-child {
		border-bottom: none;
	}
	.more-btn-content .triangle {
		display: block;
		width: 0;
		height: 0;
		border-width: 0 6px 6px;
		border-style: solid;
		border-color: transparent transparent #999;
		position: absolute;
		top: -6px;
		left: 50%;
		/* 三角形居中显示 */
		margin-left: -6px;
	}
	.more-btn-content .triangle em {
		display: block;
		width: 0;
		height: 0;
		border-width: 0 10px 10px;
		border-style: solid;
		border-color: transparent transparent #fff;
		position: absolute;
		top: 1px;
		left: -10px;
	}
	.message {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 30px;
		background: #f5f6fa;
		margin: 12px 15px 0 45px;
		border-radius: 5px;
	}
	.message .message-text {
		width: 100%;
		display: inline-block;
		font-size: 13px;
		color: #999;
		padding: 0 10px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/orderitem.vue